export default __webpack_public_path__ + "static/media/image3.92cc7112.jpg";